// Vision
// mlp-ui-service serves the vision nav link under one of two environment-specific ids -- VIS-PROD in
// prod, VIS-NP everywhere else -- mirroring the DEN-PROD/DEN-NP split it already uses for dental.
// Anything keying off the vision link must match against this list rather than a single literal,
// otherwise the link silently stops being recognised in one environment.
export const VISION_NAV_IDS = ['VIS-PROD', 'VIS-NP'];
// The vision forms link is not environment-split, so it keeps its single id.
export const VISION_FORM_NAV_ID = 'VIS_FORM';
// The vision portal link plus its forms link, for the places that treat them as one group.
export const VISION_AND_FORM_NAV_IDS = [...VISION_NAV_IDS, VISION_FORM_NAV_ID];
// Dental -- only applies to the new ee nav.
export const DENTAL_NAV_IDS = ['DEN-PROD', 'DEN-NP', 'DENTAL-FORMS'];
// DHMO
export const DHMO_NAV_ID = 'DHMO';
export const DHMO_FORM_NAV_ID = 'DENTAL-HMO-FORMS';
export const DHMO_NAV_IDS = [DHMO_NAV_ID, DHMO_FORM_NAV_ID];
/**
 * Nav links that leave MLP for a third-party portal and so must route through the ThirdPartyModal
 * before navigating.
 */
export const isThirdPartyNavId = (id) => !!id && (VISION_NAV_IDS.includes(id) || id === DHMO_NAV_ID);
/**
 * The vision (Spectera) portal link, in either environment. Used to pick the vision-specific
 * ThirdPartyModal copy; excludes VIS_FORM, which is a forms link and not a portal exit.
 */
export const isVisionNavId = (id) => !!id && VISION_NAV_IDS.includes(id);
